






import page from "./page.vue";
export default {
    components: {
        page
    }
};
